import PhotoSwipeLightbox from 'photoswipe/lightbox'
import PhotoSwipe from 'photoswipe'
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin'
import { isMobileDevice } from './helpers'

const xMarkSVGString =
  '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="pswp__icn" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd"/></svg>'
const leftArrowSVGString =
  '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="pswp__icn" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M11.03 3.97a.75.75 0 0 1 0 1.06l-6.22 6.22H21a.75.75 0 0 1 0 1.5H4.81l6.22 6.22a.75.75 0 1 1-1.06 1.06l-7.5-7.5a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 0 1 1.06 0Z" clip-rule="evenodd"/></svg>'

export default function lightbox(trigger, options) {
  options = options || {}

  const pswpOptions = options.pswpOptions || {}
  const isDynamic = options.isDynamic
  const captionContent = options.captionContent
  const historyHash =
    options.historyHash === undefined ? 'lightbox_open' : options.historyHash

  const triggers = document.querySelectorAll(trigger)

  const dataSource = !isDynamic
    ? [...triggers].map(getDataSourceFromImgElement)
    : undefined

  const lbox = new PhotoSwipeLightbox({
    dataSource,
    pswpModule: PhotoSwipe,
    bgOpacity: 0.95,
    arrowPrevSVG: leftArrowSVGString,
    arrowNextSVG: leftArrowSVGString,
    closeSVG: xMarkSVGString,
    zoom: false,
    paddingFn: function (viewportSize, _itemData, _index) {
      return viewportSize.x < 600
        ? {}
        : { top: 40, bottom: captionContent ? 120 : 40, left: 100, right: 100 }
    },
    ...pswpOptions,
  })

  if (isDynamic) {
    lbox.addFilter('numItems', function (_numItems) {
      const items = document.querySelectorAll(trigger)
      return items.length
    })

    lbox.addFilter('itemData', function (_itemData, index) {
      const items = document.querySelectorAll(trigger)
      const item = items[index]

      return item ? getDataSourceFromImgElement(item) : null
    })
  }

  if (captionContent) {
    // eslint-disable-next-line no-new
    new PhotoSwipeDynamicCaption(lbox, {
      captionContent,
      type: 'below',
      mobileLayoutBreakpoint: function () {
        return true
      },
    })
  }

  lbox.init()

  if (!isDynamic) {
    triggers.forEach(function (trigger, index) {
      trigger.addEventListener('click', function (e) {
        lbox.loadAndOpen(index)
      })
    })
  }

  if (historyHash && isMobileDevice()) {
    const historyHashName = `#${historyHash}`
    const isLocationHashSet = () => location.hash === historyHashName

    let isGalleryOpen = false
    let pushedState = false

    function openHandler() {
      isGalleryOpen = true
      if (!isLocationHashSet()) {
        pushedState = true
        history.pushState({ gallery: true }, '', historyHashName)
      }
    }

    function closeHandler() {
      isGalleryOpen = false
      if (pushedState && isLocationHashSet()) {
        pushedState = false
        history.back()
      }
    }

    function historyChangeHandler() {
      if (isGalleryOpen && !isLocationHashSet()) {
        lbox.pswp.close()
      }
    }

    lbox.on('openingAnimationStart', openHandler)
    lbox.on('close', closeHandler)

    window.addEventListener('popstate', historyChangeHandler)
  }

  return lbox
}

function getDataSourceFromImgElement(imgElement) {
  const src = imgElement.getAttribute('src')
  const srcset = imgElement.getAttribute('srcset')
  const alt = imgElement.getAttribute('alt')

  let width = imgElement.getAttribute('width')
  let height = imgElement.getAttribute('height')

  if (!width || !height) {
    const newDimensions = resizeDimensions(
      {
        width: imgElement.naturalWidth,
        height: imgElement.naturalHeight,
      },
      { width: 1920, height: 1280 }
    )
    width = newDimensions.width
    height = newDimensions.height
  }

  return {
    src,
    srcset,
    width,
    height,
    alt,
    element: imgElement,
    msrc: src,
    w: width,
    h: height,
    thumbCropped: true,
  }
}

function resizeDimensions(dimensions, maxDimensions) {
  const ratio = Math.min(
    maxDimensions.width / dimensions.width,
    maxDimensions.height / dimensions.height
  )
  const width = ratio * dimensions.width
  const height = ratio * dimensions.height
  return { width, height }
}
